// Action Type for Navigation Menu

// Get Navigation Menu
export const GET_NAVIGATION_MENU = "GET_NAVIGATION_MENU";
export const GET_NAVIGATION_MENU_SUCCESS = "GET_NAVIGATION_MENU_SUCCESS";
export const GET_NAVIGATION_MENU_FAILURE = "GET_NAVIGATION_MENU_FAILURE";

// Role Based Navigation Menu
export const ROLE_BASED_NAVIGATION_MENU = "ROLE_BASED_NAVIGATION_MENU";
export const ROLE_BASED_NAVIGATION_MENU_SUCCESS =
  "ROLE_BASED_NAVIGATION_MENU_SUCCESS";
export const ROLE_BASED_NAVIGATION_MENU_FAILURE =
  "ROLE_BASED_NAVIGATION_MENU_FAILURE";

// Get menu navigation list
export const GET_MENU_NAVIGATION_LIST = "GET_MENU_NAVIGATION_LIST";
export const GET_MENU_NAVIGATION_LIST_SUCCESS =
  "GET_MENU_NAVIGATION_LIST_SUCCESS";
export const GET_MENU_NAVIGATION_LIST_FAILURE =
  "GET_MENU_NAVIGATION_LIST_FAILURE";

// Create Single Menu Navigation
export const CREATE_SINGLE_MENU_NAVIGATION = "CREATE_SINGLE_MENU_NAVIGATION";
export const CREATE_SINGLE_MENU_NAVIGATION_SUCCESS =
  "CREATE_SINGLE_MENU_NAVIGATION_SUCCESS";
export const CREATE_SINGLE_MENU_NAVIGATION_FAILURE =
  "CREATE_SINGLE_MENU_NAVIGATION_FAILURE";

// Update Single Menu Navigation
export const UPDATE_SINGLE_MENU_NAVIGATION = "UPDATE_SINGLE_MENU_NAVIGATION";
export const UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS =
  "UPDATE_SINGLE_MENU_NAVIGATION_SUCCESS";
export const UPDATE_SINGLE_MENU_NAVIGATION_FAILURE =
  "UPDATE_SINGLE_MENU_NAVIGATION_FAILURE";

// Delete Single Menu Navigation
export const DELETE_SINGLE_MENU_NAVIGATION = "DELETE_SINGLE_MENU_NAVIGATION";
export const DELETE_SINGLE_MENU_NAVIGATION_SUCCESS =
  "DELETE_SINGLE_MENU_NAVIGATION_SUCCESS";
export const DELETE_SINGLE_MENU_NAVIGATION_FAILURE =
  "DELETE_SINGLE_MENU_NAVIGATION_FAILURE";

// Get Available Menu Navigation Items
export const GET_AVAILABLE_MENU_NAVIGATION_ITEMS =
  "GET_AVAILABLE_MENU_NAVIGATION_ITEMS";
export const GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS =
  "GET_AVAILABLE_MENU_NAVIGATION_ITEMS_SUCCESS";
export const GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE =
  "GET_AVAILABLE_MENU_NAVIGATION_ITEMS_FAILURE";

// Get Single Navigation Menu
export const GET_SINGLE_NAVIGATION_MENU = "GET_SINGLE_NAVIGATION_MENU";
export const GET_SINGLE_NAVIGATION_MENU_SUCCESS =
  "GET_SINGLE_NAVIGATION_MENU_SUCCESS";
export const GET_SINGLE_NAVIGATION_MENU_FAILURE =
  "GET_SINGLE_NAVIGATION_MENU_FAILURE";

// Get Menu Item List
export const GET_MENU_ITEM_LIST = "GET_MENU_ITEM_LIST";
export const GET_MENU_ITEM_LIST_SUCCESS = "GET_MENU_ITEM_LIST_SUCCESS";
export const GET_MENU_ITEM_LIST_FAILURE = "GET_MENU_ITEM_LIST_FAILURE";

// Get Single Menu Item DATA
export const GET_SINGLE_MENU_ITEM_DATA = "GET_SINGLE_MENU_ITEM_DATA";
export const GET_SINGLE_MENU_ITEM_DATA_SUCCESS =
  "GET_SINGLE_MENU_ITEM_DATA_SUCCESS";
export const GET_SINGLE_MENU_ITEM_DATA_FAILURE =
  "GET_SINGLE_MENU_ITEM_DATA_FAILURE";

// Create Single Menu Item
export const CREATE_SINGLE_MENU_ITEM = "CREATE_SINGLE_MENU_ITEM";
export const CREATE_SINGLE_MENU_ITEM_SUCCESS =
  "CREATE_SINGLE_MENU_ITEM_SUCCESS";
export const CREATE_SINGLE_MENU_ITEM_FAILURE =
  "CREATE_SINGLE_MENU_ITEM_FAILURE";

// Update Single Menu Item
export const UPDATE_SINGLE_MENU_ITEM = "UPDATE_SINGLE_MENU_ITEM";
export const UPDATE_SINGLE_MENU_ITEM_SUCCESS =
  "UPDATE_SINGLE_MENU_ITEM_SUCCESS";
export const UPDATE_SINGLE_MENU_ITEM_FAILURE =
  "UPDATE_SINGLE_MENU_ITEM_FAILURE";

// Delete Single Menu Item
export const DELETE_SINGLE_MENU_ITEM = "DELETE_SINGLE_MENU_ITEM";
export const DELETE_SINGLE_MENU_ITEM_SUCCESS =
  "DELETE_SINGLE_MENU_ITEM_SUCCESS";
export const DELETE_SINGLE_MENU_ITEM_FAILURE =
  "DELETE_SINGLE_MENU_ITEM_FAILURE";
///mastermenunavitem/create
export const CREATE_MASTER_MENU_NAV_ITEM = "CREATE_MASTER_MENU_NAV_ITEM";
export const CREATE_MASTER_MENU_NAV_ITEM_SUCCESS =
  "CREATE_MASTER_MENU_NAV_ITEM_SUCCESS";
export const CREATE_MASTER_MENU_NAV_ITEM_FAILURE =
  "CREATE_MASTER_MENU_NAV_ITEM_FAILURE";

// ---------------------------------------------------------------------------
// Global (platform-wide) menus - Task 24886. Defined in ZCRM_Master, rolled
// out into every company database. Super Admin only.
// ---------------------------------------------------------------------------
export const GET_MASTER_MENU_NAV_LIST = "GET_MASTER_MENU_NAV_LIST";
export const GET_MASTER_MENU_NAV_LIST_SUCCESS =
  "GET_MASTER_MENU_NAV_LIST_SUCCESS";
export const GET_MASTER_MENU_NAV_LIST_FAILURE =
  "GET_MASTER_MENU_NAV_LIST_FAILURE";

export const GET_MASTER_MENU_NAV_DATA = "GET_MASTER_MENU_NAV_DATA";
export const GET_MASTER_MENU_NAV_DATA_SUCCESS =
  "GET_MASTER_MENU_NAV_DATA_SUCCESS";
export const GET_MASTER_MENU_NAV_DATA_FAILURE =
  "GET_MASTER_MENU_NAV_DATA_FAILURE";

export const CREATE_MASTER_MENU_NAV = "CREATE_MASTER_MENU_NAV";
export const CREATE_MASTER_MENU_NAV_SUCCESS = "CREATE_MASTER_MENU_NAV_SUCCESS";
export const CREATE_MASTER_MENU_NAV_FAILURE = "CREATE_MASTER_MENU_NAV_FAILURE";

export const UPDATE_MASTER_MENU_NAV = "UPDATE_MASTER_MENU_NAV";
export const UPDATE_MASTER_MENU_NAV_SUCCESS = "UPDATE_MASTER_MENU_NAV_SUCCESS";
export const UPDATE_MASTER_MENU_NAV_FAILURE = "UPDATE_MASTER_MENU_NAV_FAILURE";

export const DELETE_MASTER_MENU_NAV = "DELETE_MASTER_MENU_NAV";
export const DELETE_MASTER_MENU_NAV_SUCCESS = "DELETE_MASTER_MENU_NAV_SUCCESS";
export const DELETE_MASTER_MENU_NAV_FAILURE = "DELETE_MASTER_MENU_NAV_FAILURE";

export const ROLLOUT_MASTER_MENU_NAV = "ROLLOUT_MASTER_MENU_NAV";
export const ROLLOUT_MASTER_MENU_NAV_SUCCESS =
  "ROLLOUT_MASTER_MENU_NAV_SUCCESS";
export const ROLLOUT_MASTER_MENU_NAV_FAILURE =
  "ROLLOUT_MASTER_MENU_NAV_FAILURE";

